module.exports = __webpack_public_path__ + "static/media/background_small.638717eb.jpg";